(function () {
  function getRows(wrapper) {
    return Array.from(wrapper.querySelectorAll('[data-bulk-row]'))
  }

  function getRowVariants(row) {
    return Array.from(row.querySelectorAll('[data-bulk-variant-json]'))
      .map(function (node) {
        try {
          return JSON.parse(node.textContent)
        } catch (e) {
          return null
        }
      })
      .filter(Boolean)
  }

  function getSelectedOption(wrapper) {
    var checked = wrapper.querySelector('[data-bulk-option-input]:checked')
    return checked ? checked.value : ''
  }

  // Parse a localized (nl-NL) money string like "1.234,56 incl. BTW" -> 1234.56
  function parsePrice(text) {
    if (text == null) return null
    var match = String(text).match(/[\d.\s]*\d(?:,\d{1,2})?/)
    if (!match) return null
    var cleaned = match[0].replace(/[.\s]/g, '').replace(',', '.')
    var value = parseFloat(cleaned)
    return isNaN(value) ? null : value
  }

  function formatDutch(value) {
    try {
      return value.toLocaleString('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    } catch (e) {
      return value.toFixed(2).replace('.', ',')
    }
  }

  // Returns { incl, excl } unit prices for a row, preferring the rendered
  // BSS B2B price (which reflects customer-specific custom pricing) and
  // falling back to the base variant price from the JSON.
  function getRowUnitPrice(row) {
    var result = { incl: null, excl: null }

    var inclEl = row.querySelector('.bss-b2b-price-has-vat')
    var exclEl = row.querySelector('.bss-b2b-price-no-vat')

    if (inclEl) result.incl = parsePrice(inclEl.textContent)
    if (exclEl) result.excl = parsePrice(exclEl.textContent)

    // Fallback: use the data-price (cents) the JS keeps in sync, else the
    // active variant's JSON price.
    if (result.incl == null) {
      var b2b = row.querySelector('[data-bulk-b2b-price]')
      var cents = b2b && b2b.getAttribute('data-price')
      if (cents) {
        result.incl = parseInt(cents, 10) / 100
      } else {
        var active = row.querySelector('[data-bulk-active-variant-id]')
        var id = active ? active.getAttribute('data-bulk-active-variant-id') : null
        var matched = getRowVariants(row).find(function (v) {
          return String(v.id) === String(id)
        })
        if (matched && typeof matched.price === 'number') {
          result.incl = matched.price / 100
        }
      }
    }

    return result
  }

  // Header EXCL/INCL BTW switch. On (aria-checked="true") => incl. BTW.
  function isInclMode() {
    var sw = document.getElementById('switch1') ||
      document.querySelector('[role="switch"]')
    if (!sw) return true
    return sw.getAttribute('aria-checked') === 'true' ||
      sw.getAttribute('data-active') === 'true'
  }

  // ---- B2B price loading indicator (three dots) -------------------------
  // The BSS B2B app rewrites each price asynchronously. We show animated
  // dots until the app has injected its custom-price spans, so the customer
  // never sees a stale/base price flash. Covers three cases: initial page
  // load, the EXCL/INCL BTW switch, and switching the variant option.

  var PRICE_LOAD_MAX_MS = 6000 // safety net: never show dots longer than this
  var PRICE_LOAD_MIN_MS = 450 // keep dots visible at least this long (switch)

  function getPriceCell(row) {
    return row ? row.querySelector('.x-bulk-order__price') : null
  }

  // The app has finished when it has injected its VAT price spans.
  function isB2BPriceReady(cell) {
    if (!cell) return true
    var inner = cell.querySelector('[data-bulk-b2b-price]')
    if (!inner) return true
    return !!inner.querySelector('.bss-b2b-price-no-vat, .bss-b2b-price-has-vat')
  }

  function clearPriceLoading(cell) {
    if (!cell) return
    cell.classList.remove('is-price-loading')
    if (cell._bulkLoadTimer) {
      clearTimeout(cell._bulkLoadTimer)
      cell._bulkLoadTimer = null
    }
  }

  function startPriceLoading(cell, minMs) {
    if (!cell) return
    cell.classList.add('is-price-loading')
    cell._bulkLoadStart = Date.now()
    cell._bulkLoadMin = minMs || 0
    if (cell._bulkLoadTimer) clearTimeout(cell._bulkLoadTimer)
    cell._bulkLoadTimer = setTimeout(function () {
      clearPriceLoading(cell)
    }, PRICE_LOAD_MAX_MS)
  }

  // Clear the dots once the app price is ready and the minimum visible
  // time has elapsed. Safe to call repeatedly (e.g. from the observer).
  function maybeClearPriceLoading(cell) {
    if (!cell || !cell.classList.contains('is-price-loading')) return
    if (!isB2BPriceReady(cell)) return

    var elapsed = Date.now() - (cell._bulkLoadStart || 0)
    var min = cell._bulkLoadMin || 0

    if (elapsed >= min) {
      clearPriceLoading(cell)
    } else if (!cell._bulkLoadMinTimer) {
      cell._bulkLoadMinTimer = setTimeout(function () {
        cell._bulkLoadMinTimer = null
        if (isB2BPriceReady(cell)) clearPriceLoading(cell)
      }, min - elapsed)
    }
  }

  function refreshPriceLoaders(wrapper) {
    if (!wrapper) return
    wrapper.querySelectorAll('.x-bulk-order__price').forEach(function (cell) {
      maybeClearPriceLoading(cell)
    })
  }

  function showPriceLoadingAll(wrapper, minMs) {
    if (!wrapper) return
    wrapper.querySelectorAll('.x-bulk-order__price').forEach(function (cell) {
      startPriceLoading(cell, minMs)
    })
  }
  // -----------------------------------------------------------------------

  function recalcTotals(wrapper) {
    if (!wrapper) return

    var summary = wrapper.querySelector('[data-bulk-summary]')
    if (!summary) return

    var totalItems = 0
    var totalIncl = 0
    var totalExcl = 0
    var haveExcl = true

    getRows(wrapper).forEach(function (row) {
      var qtyInput = row.querySelector('[data-bulk-qty]')
      var qty = qtyInput ? parseInt(qtyInput.value || '0', 10) : 0
      if (!qty || qty < 0) return

      totalItems += qty

      var unit = getRowUnitPrice(row)
      if (unit.incl != null) totalIncl += unit.incl * qty
      if (unit.excl != null) {
        totalExcl += unit.excl * qty
      } else {
        haveExcl = false
      }
    })

    var itemsEl = summary.querySelector('[data-bulk-total-items]')
    var amountEl = summary.querySelector('[data-bulk-total-amount]')
    var suffixEl = summary.querySelector('[data-bulk-total-suffix]')

    if (itemsEl) itemsEl.textContent = totalItems

    // Switch on => incl. (bss-b2b-price-has-vat), off => excl.
    // (bss-b2b-price-no-vat). Fall back to incl. if excl. is unavailable.
    var showIncl = isInclMode() || !haveExcl
    if (amountEl) {
      amountEl.textContent = formatDutch(showIncl ? totalIncl : totalExcl)
    }
    if (suffixEl) {
      suffixEl.textContent = showIncl ? 'incl. BTW' : 'excl. BTW'
    }

    if (totalItems > 0) {
      summary.removeAttribute('hidden')
    } else {
      summary.setAttribute('hidden', '')
    }
  }

  function renderStock(variant, inStockLabel, outOfStockLabel) {
  if (!variant) return '';
  
  // Use the delivery time strings passed from the JSON
  var deliveryText = variant.available ? variant.delivery_in : variant.delivery_out;
  var statusClass = variant.available ? 'x-bulk-order__stock--in' : 'x-bulk-order__stock--out';

  return '<span class="x-bulk-order__stock ' + statusClass + '">' + (deliveryText || outOfStockLabel) + '</span>';
}

  function formatMoneyFromCents(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : undefined)
    }

    return (cents / 100).toFixed(2)
  }

  function updateDisplayedPrice(el, matched) {
    if (!el || !matched) return

    el.setAttribute('bss-b2b-variant-id', matched.id)
    el.setAttribute('bss-b2b-product-id', matched.product_id)
    el.setAttribute('data-variant-id', matched.id)
    el.setAttribute('data-product-id', matched.product_id)
    el.setAttribute('data-price', matched.price)
    el.textContent = matched.price_formatted

    triggerB2BPriceUpdate(el, matched)
    retryB2BPriceUpdate(el, matched, 8, 250)
  }

  function retryB2BPriceUpdate(el, matched, retries, delay) {
    if (!el || !matched || retries <= 0) return

    setTimeout(function () {
      triggerB2BPriceUpdate(el, matched)
      retryB2BPriceUpdate(el, matched, retries - 1, delay)
    }, delay)
  }

  function syncRow(row, selectedOption, inStockLabel, outOfStockLabel) {
    var variants = getRowVariants(row)
    if (!variants.length) return

    var matched = variants.find(function (variant) {
      return String(variant.option_value) === String(selectedOption)
    })

    if (!matched) matched = variants[0]
    if (!matched) return

    var active = row.querySelector('[data-bulk-active-variant-id]')
    var price = row.querySelector('[data-bulk-price]')
    var b2bPrice = row.querySelector('[data-bulk-b2b-price]')
    var stock = row.querySelector('[data-bulk-stock]')

    if (active) {
      active.setAttribute('data-bulk-active-variant-id', matched.id)
      active.value = matched.id
    }

    if (b2bPrice) {
      // Updating the price wipes the app's custom-price spans, so show the
      // loading dots until the app re-renders the customer price.
      startPriceLoading(getPriceCell(row), 0)
      updateDisplayedPrice(b2bPrice, matched)
    } else if (price) {
      price.textContent = matched.price_formatted
    }

    if (stock) {
      stock.innerHTML = renderStock(matched, inStockLabel, outOfStockLabel)
    }

    row.setAttribute('data-current-variant-id', matched.id)
    row.setAttribute('data-current-option', matched.option_value || '')
  }

  function triggerB2BPriceUpdate(el, matched) {
    try {
      if (window.bssB2b && typeof window.bssB2b.updatePrice === 'function') {
        window.bssB2b.updatePrice(el, matched.id)
      }
    } catch (e) {}

    try {
      if (window.BSS_B2B && BSS_B2B.cp && BSS_B2B.cp.utils && typeof BSS_B2B.cp.utils.renderPrice === 'function') {
        BSS_B2B.cp.utils.renderPrice(el, matched.id)
      }
    } catch (e) {}

    var eventDetail = {
      variantId: matched.id,
      productId: matched.product_id,
      variant: matched
    }

    try {
      el.dispatchEvent(new CustomEvent('bss-b2b:variant-changed', {
        bubbles: true,
        detail: eventDetail
      }))
    } catch (e) {}

    try {
      document.dispatchEvent(new CustomEvent('bss-b2b:variant-changed', {
        bubbles: true,
        detail: eventDetail
      }))
    } catch (e) {}

    try {
      document.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: eventDetail
      }))
    } catch (e) {}

    try {
      document.dispatchEvent(new CustomEvent('theme:variant:change', {
        bubbles: true,
        detail: eventDetail
      }))
    } catch (e) {}
  }

  function syncAll(wrapper) {
    if (!wrapper) return

    var selectedOption = getSelectedOption(wrapper)
    var inStockLabel = wrapper.getAttribute('data-in-stock-label') || '200+ stuks'
    var outOfStockLabel = wrapper.getAttribute('data-out-of-stock-label') || 'Niet op voorraad'

    getRows(wrapper).forEach(function (row) {
      syncRow(row, selectedOption, inStockLabel, outOfStockLabel)
    })

    recalcTotals(wrapper)
  }

  // The BSS B2B app rewrites the price spans asynchronously after load and
  // on its own events. Watch the table so totals follow the custom prices.
  function observeB2BPrices(wrapper) {
    if (typeof MutationObserver === 'undefined') return
    if (wrapper.hasAttribute('data-bulk-price-observed')) return

    var table = wrapper.querySelector('.x-bulk-order__table')
    if (!table) return

    wrapper.setAttribute('data-bulk-price-observed', 'true')

    var scheduled = false
    var priceObserver = new MutationObserver(function () {
      if (scheduled) return
      scheduled = true
      window.requestAnimationFrame(function () {
        scheduled = false
        refreshPriceLoaders(wrapper)
        recalcTotals(wrapper)
      })
    })

    priceObserver.observe(table, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    })
  }

  function setMessage(wrapper, text, type) {
    var message = wrapper.querySelector('[data-bulk-message]')
    if (!message) return

    message.textContent = text || ''
    message.classList.remove('is-success', 'is-error')

    if (type) {
      message.classList.add(type)
    }
  }

  function updateCartCount(cart) {
    var count = cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0
    var selectors = [
      '#cart-count',
      '[data-cart-count]',
      '[data-cart-number]',
      '.cart-count',
      '.cart-number',
      '.header-cart-count',
      '.site-header__cart-count',
      '.js-cart-count'
    ]

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = count
        el.classList.remove('hidden')
        el.removeAttribute('hidden')
        el.style.display = ''
      })
    })

    var cartLinks = document.querySelectorAll('li.cart a, a[data-panel="cart"]')
    cartLinks.forEach(function (link) {
      var label = link.getAttribute('aria-label') || 'Cart'
      var cleanLabel = label.replace(/\s\d+\s*$/, '').replace(/\s€.*$/, '').trim()
      link.setAttribute('aria-label', cleanLabel + ' ' + count)
    })

    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }))
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }))
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }))

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }))
    document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }))

    window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
    window.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }))
    window.dispatchEvent(new CustomEvent('cart:change', { detail: cart }))
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    }).then(function (response) {
      return response.json()
    })
  }

  function addItems(wrapper, button) {
    var items = getRows(wrapper)
      .map(function (row) {
        var qtyInput = row.querySelector('[data-bulk-qty]')
        var active = row.querySelector('[data-bulk-active-variant-id]')
        var variants = getRowVariants(row)
        var quantity = qtyInput ? parseInt(qtyInput.value || '0', 10) : 0
        var id = active ? parseInt(active.getAttribute('data-bulk-active-variant-id') || '0', 10) : 0

        if (!quantity || !id) return null

        var matched = variants.find(function (variant) {
          return Number(variant.id) === Number(id)
        })

        if (!matched || !matched.available) return null

        return {
          id: id,
          quantity: quantity
        }
      })
      .filter(Boolean)

    if (!items.length) {
      setMessage(wrapper, wrapper.getAttribute('data-empty-label') || 'Selecteer minimaal 1 aantal.', 'is-error')
      return
    }

    button.disabled = true
    setMessage(wrapper, '', '')

    // Ask Shopify's bundled-sections rendering to return the side-cart
    // markup alongside the cart payload so we can hand it straight to the
    // theme's ajaxCart pipeline (same code path the normal Add-to-cart
    // button uses — updates totals AND opens the side cart drawer).
    var sectionsToFetch = 'side-cart'
    var cartPageSection = null
    var cartPageContainer = document.querySelector('.form-cart, .cart-empty')
    if (cartPageContainer) {
      var sectionRoot = cartPageContainer.closest('[id^="shopify-section-"]')
      if (sectionRoot) {
        cartPageSection = sectionRoot.id.replace('shopify-section-', '')
        sectionsToFetch = 'side-cart,' + cartPageSection
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items, sections: sectionsToFetch })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) { throw data })
        }
        return response.json()
      })
      .then(function (addResponse) {
        // Hand the response to the theme's ajaxCart module if it's
        // available — this replaces the side-cart HTML (so the total
        // updates), wires up the new line items, and opens the drawer.
        var handed = false
        try {
          if (window.ajaxCart && typeof window.ajaxCart.load === 'function' && addResponse && addResponse.sections && addResponse.sections['side-cart']) {
            window.ajaxCart.load(addResponse)
            handed = true
          }
        } catch (e) {}

        return fetchCart().then(function (cart) {
          return { cart: cart, handed: handed, addResponse: addResponse }
        })
      })
      .then(function (result) {
        var cart = result.cart
        var handed = result.handed

        // If the theme's ajaxCart already updated the side cart, skip our
        // manual count update (it would race with ajaxCart's own update).
        if (!handed) {
          updateCartCount(cart)
        }

        try {
          if (window.theme && typeof window.theme.updateCart === 'function') {
            window.theme.updateCart(cart)
          }
        } catch (e) {}

        try {
          if (window.refreshCartDrawer && typeof window.refreshCartDrawer === 'function') {
            window.refreshCartDrawer()
          }
        } catch (e) {}

        try {
          if (window.Shopify && window.Shopify.theme && window.Shopify.theme.cartDrawer && typeof window.Shopify.theme.cartDrawer.refresh === 'function') {
            window.Shopify.theme.cartDrawer.refresh()
          }
        } catch (e) {}
        setMessage(wrapper, wrapper.getAttribute('data-added-label') || 'Producten zijn toegevoegd aan de winkelwagen.', 'is-success')
        triggerBSSCartUpdate(cart)

        // Final safety net: if the theme module wasn't around for some
        // reason, open the side cart manually so the user still sees feedback.
        if (!handed) {
          openSideCartFallback()
        }
      })
      .catch(function () {
        setMessage(wrapper, wrapper.getAttribute('data-error-label') || 'Er ging iets mis. Probeer opnieuw.', 'is-error')
      })
      .finally(function () {
        button.disabled = false
      })
  }

  // Best-effort fallback for opening the side cart when the theme's
  // ajaxCart module isn't reachable (e.g. on cart-drawer-disabled themes
  // or while the async bundle is still loading).
  function openSideCartFallback() {
    try {
      if (typeof window.openPanel === 'function') {
        window.openPanel('cart')
        return
      }
    } catch (e) {}

    var trigger = document.querySelector('a[data-panel="cart"], li.cart > a, a[href$="/cart"][data-panel]')
    if (trigger) {
      try { trigger.click() } catch (e) {}
    }
  }

  function triggerBSSCartUpdate(cart) {
    try {
      var cartProto = Object.getPrototypeOf(BSS_B2B.cp.utils.cart)

      cart.items.forEach(function (cartItem) {
        var existing = BSS_B2B.storage.cartStorage.get(cartItem.key)
        if (!existing) {
          BSS_B2B.storage.cartStorage.set(cartItem.key, cartItem)
        }
      })

      cartProto.initPriceList.call(BSS_B2B.cp.utils.cart)

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }))
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }))

      waitForCartDOMAndApplyPrices(50, 8)
    } catch (e) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }))
    }
  }

  function waitForCartDOMAndApplyPrices(delay, retries) {
    if (retries <= 0) return

    setTimeout(function () {
      try {
        var cartProto = Object.getPrototypeOf(BSS_B2B.cp.utils.cart)
        cartProto.initPriceList.call(BSS_B2B.cp.utils.cart)

        BSS_B2B.storage.cartStorage.getAllItem().forEach(function (item) {
          if (!item.bssB2BPriceAfterCP) return

          var cartItemEls = document.querySelectorAll(
            '[data-variant-id="' + item.variant_id + '"], ' +
            '[data-key="' + item.key + '"], ' +
            '[data-cart-item-key="' + item.key + '"]'
          )

          cartItemEls.forEach(function () {
            try {
              BSS_B2B.cp.utils.cart.showPrice(item.key)
            } catch (e) {}
          })

          try {
            BSS_B2B.cp.utils.cart.showPrice(item.key)
          } catch (e) {}
        })

        document.dispatchEvent(new CustomEvent('CustomCartUpdate', { bubbles: true }))
      } catch (e) {}

      waitForCartDOMAndApplyPrices(delay * 1.5, retries - 1)
    }, delay)
  }

  function initWrapper(wrapper) {
    if (!wrapper || wrapper.hasAttribute('data-bulk-order-initialized')) {
      syncAll(wrapper)
      return
    }

    wrapper.setAttribute('data-bulk-order-initialized', 'true')

    if (!wrapper.querySelector('[data-bulk-option-input]:checked')) {
      var firstInput = wrapper.querySelector('[data-bulk-option-input]')
      if (firstInput) firstInput.checked = true
    }

    syncAll(wrapper)
    observeB2BPrices(wrapper)

    // Recalc a few times after load to catch the async B2B price render,
    // and clear any price-loading dots once the app price is ready.
    ;[300, 800, 1500, 3000].forEach(function (delay) {
      setTimeout(function () {
        refreshPriceLoaders(wrapper)
        recalcTotals(wrapper)
      }, delay)
    })
  }

  function init(scope) {
    var root = scope && scope.nodeType === 1 ? scope : document
    root.querySelectorAll('[data-bulk-order]').forEach(function (wrapper) {
      initWrapper(wrapper)
    })
  }

  function handleQtyChange(event) {
    var qtyInput = event.target.closest('[data-bulk-qty]')
    if (!qtyInput) return
    var wrapper = qtyInput.closest('[data-bulk-order]')
    if (wrapper) recalcTotals(wrapper)
  }

  document.addEventListener('input', handleQtyChange)

  // Keep totals in sync with the header EXCL/INCL BTW switch.
  function recalcAllTotals() {
    document.querySelectorAll('[data-bulk-order]').forEach(function (wrapper) {
      refreshPriceLoaders(wrapper)
      recalcTotals(wrapper)
    })
  }

  // Show the loading dots on every price while the app re-applies the
  // selected VAT mode, then recalc.
  function onVatModeChange() {
    document.querySelectorAll('[data-bulk-order]').forEach(function (wrapper) {
      showPriceLoadingAll(wrapper, PRICE_LOAD_MIN_MS)
    })
    ;[0, 100, 300, 600].forEach(function (delay) {
      setTimeout(recalcAllTotals, delay)
    })
  }

  // Delegated click — survives the switch node being re-rendered by the app.
  document.addEventListener('click', function (event) {
    if (event.target.closest('#switch1, [role="switch"]')) {
      onVatModeChange()
    }
  })

  // Safety net: poll the switch state and recalc whenever it changes. Covers
  // programmatic toggles and node replacement the click handler can't see.
  var lastInclMode = isInclMode()
  setInterval(function () {
    var mode = isInclMode()
    if (mode !== lastInclMode) {
      lastInclMode = mode
      onVatModeChange()
    }
  }, 400)

  document.addEventListener('change', function (event) {
    var optionInput = event.target.closest('[data-bulk-option-input]')
    if (optionInput) {
      var wrapper = optionInput.closest('[data-bulk-order]')
      if (wrapper) {
        syncAll(wrapper)
      }
      return
    }

    handleQtyChange(event)

    var variantInput = event.target.closest('select[name="id"], input[name="id"], [name="id"]')
    if (variantInput) {
      var quickViewWrapper = variantInput.closest('.quick-add-modal, .quick-shop, .quickview, .product-quickview, .modal, .drawer, [data-product-root], [data-product-id]')
      if (quickViewWrapper) {
        init(quickViewWrapper)
      }
    }
  })

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.x-bulk-order__form')
    if (!form) return

    // Prevent the native /cart/add submit (which would add the parent
    // product). Route through the JS add path instead.
    event.preventDefault()

    var wrapper = form.closest('[data-bulk-order]')
    var add = wrapper ? wrapper.querySelector('[data-bulk-add]') : null
    if (wrapper && add) addItems(wrapper, add)
  })

  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-bulk-qty-minus]')
    if (minus) {
      var box = minus.closest('.x-bulk-order__qty-box')
      var input = box ? box.querySelector('[data-bulk-qty]') : null

      if (!input) return

      input.value = Math.max(0, parseInt(input.value || '0', 10) - 1)
      input.dispatchEvent(new Event('change', { bubbles: true }))
      return
    }

    var plus = event.target.closest('[data-bulk-qty-plus]')
    if (plus) {
      var box = plus.closest('.x-bulk-order__qty-box')
      var input = box ? box.querySelector('[data-bulk-qty]') : null

      if (!input) return

      input.value = parseInt(input.value || '0', 10) + 1
      input.dispatchEvent(new Event('change', { bubbles: true }))
      return
    }

    var add = event.target.closest('[data-bulk-add]')
    if (add) {
      // Always stop the native form submit so the parent product (the
      // hidden `id` field) is never added to cart on its own. The JS path
      // below handles validation and adding the selected quantities.
      event.preventDefault()

      var wrapper = add.closest('[data-bulk-order]')
      if (!wrapper) return
      addItems(wrapper, add)
      return
    }

    var quickViewTrigger = event.target.closest('[data-quick-view], [data-quickview], .quick-add__submit, .quick-shop-trigger, .product-quickview-trigger')
    if (quickViewTrigger) {
      setTimeout(function () {
        init(document)
      }, 300)

      setTimeout(function () {
        init(document)
      }, 800)
    }
  })

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return

          if (node.matches && node.matches('[data-bulk-order]')) {
            initWrapper(node)
            return
          }

          if (node.querySelectorAll) {
            var wrappers = node.querySelectorAll('[data-bulk-order]')
            if (wrappers.length) {
              wrappers.forEach(function (wrapper) {
                initWrapper(wrapper)
              })
            }
          }
        })
      })
    })

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document)
    })
  } else {
    init(document)
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document)
  })

  document.addEventListener('shopify:block:select', function (event) {
    init(event.target || document)
  })
})()